export const CUIABA_TIMEZONE = 'America/Cuiaba';

/**
 * Formata uma data para o formato YYYY-MM-DD no timezone de Cuiabá-MT
 */
export const formatDateForCuiaba = (dateInput: string | Date): string => {
    let date: Date;

    if (typeof dateInput === 'string') {
        date = new Date(dateInput);
    } else {
        date = dateInput;
    }

    if (isNaN(date.getTime())) return '';

    const formatter = new Intl.DateTimeFormat('pt-BR', {
        timeZone: CUIABA_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });

    const parts = formatter.formatToParts(date);
    const year = parts.find(part => part.type === 'year')?.value;
    const month = parts.find(part => part.type === 'month')?.value;
    const day = parts.find(part => part.type === 'day')?.value;

    return `${year}-${month}-${day}`;
};

/**
 * Formata uma data para exibição no formato brasileiro no timezone de Cuiabá-MT
 */
export const formatDateDisplayCuiaba = (dateInput: string | Date): string => {
    let date: Date;

    if (typeof dateInput === 'string') {
        date = new Date(dateInput);
    } else {
        date = dateInput;
    }

    if (isNaN(date.getTime())) return '';

    const formatter = new Intl.DateTimeFormat('pt-BR', {
        timeZone: CUIABA_TIMEZONE,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });

    return formatter.format(date);
};

/**
 * Cria uma nova data no timezone de Cuiabá
 */
export const createDateInCuiaba = (year: number, month: number, day: number): Date => {
    // Criar data em Cuiabá usando o timezone correto
    const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T12:00:00`;
    return new Date(dateStr);
};

/**
 * Converte uma data para o timezone de Cuiabá e retorna as partes
 */
export const getDatePartsInCuiaba = (date: Date): { year: number; month: number; day: number } => {
    const formatter = new Intl.DateTimeFormat('pt-BR', {
        timeZone: CUIABA_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });

    const parts = formatter.formatToParts(date);

    return {
        year: parseInt(parts.find(part => part.type === 'year')?.value ?? '0'),
        month: parseInt(parts.find(part => part.type === 'month')?.value ?? '0'),
        day: parseInt(parts.find(part => part.type === 'day')?.value ?? '0')
    };
};

/**
 * Obtém a data atual no timezone de Cuiabá
 */
export const getCurrentDateInCuiaba = (): string => {
    const now = new Date();
    return formatDateForCuiaba(now);
};

/**
 * Obtém a data e hora atual no timezone de Cuiabá
 */
export const getCurrentDateTimeInCuiaba = (): string => {
    const now = new Date();

    const formatter = new Intl.DateTimeFormat('pt-BR', {
        timeZone: CUIABA_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });

    return formatter.format(now);
};
